module.exports = __webpack_public_path__ + "static/media/gpstracker.c88db0ca.svg";